<template>
  <weui-cell :link="true" @click="$emit('click')">
    <div v-if="trainer.wechat_bound" class="rich">
      <div class="avatar">
        <img :src="trainer.avatar" title="头像">
      </div>
      <div class="info">
        <div class="head">
          <slot name="title">
            <div class="title">{{ trainer.display_name }}</div>
          </slot>
          <div class="label positive" v-if="!virtual">已绑定</div>
        </div>
        <div class="info-line">
          <slot name="subtitle">微信昵称：{{ trainer.wechat_nickname }}</slot>
        </div>
        <div class="info-line">总完成{{ trainer.closed_course_count }}节，剩余{{ Math.max(trainer.course_count - trainer.closed_course_count, 0) }}节</div>
      </div>
    </div>
    <template v-else>
      <div class="title">{{ trainer.display_name }}</div>
      <div class="info-line">{{ formatCourseStats() }}</div>
    </template>
    <template slot="tips" v-if="!selecting && !trainer.wechat_bound">微信绑定</template>
  </weui-cell>
</template>

<script>
import mixinDatetime from '@/mixins/datetime';
import { WeuiCell } from '@/components/weui';

export default {
    name: 'Trainer',
    props: {
        trainer: {
            type: Object,
            required: true,
        },
        virtual: {
            type: Boolean,
            default: false,
        },
        selecting: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        formatCourseStats() {
            const courseRemains = Math.max(this.trainer.course_count - this.trainer.closed_course_count, 0);
            let text = `总完成${this.trainer.closed_course_count}节，剩余${courseRemains}节`;
            if (this.trainer.course_monthly_stats && this.trainer.course_monthly_stats.length) {
                const stat = this.trainer.course_monthly_stats[this.trainer.course_monthly_stats.length - 1];
                if (stat.closed_course_count) {
                    text = `${this.getMonth(stat.month)}月已完成${stat.closed_course_count}节，${text}`;
                }
            }

            return text;
        },
    },
    mixins: [
        mixinDatetime,
    ],
    components: {
        WeuiCell,
    },
};
</script>

<style lang="scss" scoped>
.rich {
    display: flex;
}

.simple {
    flex: auto;
}
.hint {
    flex: none;
}

.avatar {
    width: 17.066666667vw;
    height: 17.066666667vw;

    > img {
        width: 100%;
        height: 100%;
        border-radius: 1.2vw;
        border: solid 1px #b4b4b4;
    }
}

.info {
    margin-left: 3.2vw;
}

.head {
    display: flex;
    align-items: center;
}

.title {
    color: black;
    font-size: 4.8vw;
    line-height: 9.333333333vw;
}

.info-line {
    font-size: 3.466666667vw;
    line-height: 1.4;
    color: #9b9b9b;
}

.label {
    width: 12vw;
    font-size: 2.933333333vw;
    line-height: 5.333333333vw;
    margin-left: 2.666666667vw;
    text-align: center;

    &.positive {
        color: #87a56f;
        background-color: #d3ecbe;
        border: solid 1px #bbd6a5;
    }
}
</style>

<style scoped>
.weui-cell_access >>> .weui-cell__ft {
    padding-right: 12.8vw;
}

.weui-cell_access >>> .weui-cell__ft:after {
    right: 6.666666667vw;
}
</style>



// WEBPACK FOOTER //
// src/components/trainer/TrainerCell.vue